






































import { extensionsConfiguration } from './config'
import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { BubbleMenu } from '@tiptap/vue-2'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CEditorImageSelectModal: () => import('./CEditorImageSelectModal.vue'),
    CRichTextEditorLinkModal: () => import('./CRichTextEditorLinkModal.vue'),
    BubbleMenu
  },
  props: {
    extensions: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    editor: {
      type: Object,
      required: true
    },
    useBubbleMenu: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userType: 'userType'
    }),
    extensionsCommands() {
      return this.extensions
        .filter(extension => extensionsConfiguration[extension.name]?.inMenu)
        .map(extension => extensionsConfiguration[extension.name].commands)
        .flat()
    },
    loadImagesModal() {
      if (this.extensionsCommands?.length) {
        return this.extensionsCommands.filter(e => e.namespace === 'image')
          .length
      }
      return false
    },
    loadLinkModal() {
      if (this.extensionsCommands?.length) {
        return this.extensionsCommands.filter(e => e.namespace === 'link')
          .length
      }
      return false
    }
  },
  methods: {
    commandIsActive(command) {
      return this.editor.isActive(command.namespace, command.options)
    },
    executeCommand(command) {
      const originalAction = (options = command.options) => {
        return this.editor
          .chain()
          .focus()
          [command.actionName](options)
          .run()
      }

      if (command.namespace === 'image') {
        this.showImagesModal(command)
      } else if (command.namespace === 'link') {
        this.showLinkModal(command)
      } else if (command.name === 'toggleLink') {
        const url = window.prompt('URL')

        originalAction({
          href: url,
          target: '_blank'
        })
      } else {
        originalAction()
      }
    },
    showImagesModal(cmd) {
      this.$refs.images.showModal(cmd)
    },
    showLinkModal(cmd) {
      this.$refs.link.showModal(cmd)
    }
  }
})
